export enum Districts {
  MINING = 'mining',
  PRODUCTION = 'production',
  CITY = 'city',
  EXPEDITION = 'expedition'
}
